"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnauthorizedImage = void 0;
var React = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const UnauthorizedImage = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  width: "140",
  height: "140",
  viewBox: "0 0 140 140",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M70 120C97.6134 120 120 97.6574 120 69.9999C120 42.3425 97.5148 20 70 20C42.3866 20 20 42.3425 20 69.9999C20 97.6574 42.3866 120 70 120Z",
    fill: "#E6E5EF"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M26.3 13.6C27.8464 13.6 29.1 12.3464 29.1 10.8C29.1 9.2536 27.8464 8 26.3 8C24.7536 8 23.5 9.2536 23.5 10.8C23.5 12.3464 24.7536 13.6 26.3 13.6Z",
    fill: "#9F9FBC"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M9.2 67.6002C12.0719 67.6002 14.4 65.2721 14.4 62.4002C14.4 59.5283 12.0719 57.2002 9.2 57.2002C6.32811 57.2002 4 59.5283 4 62.4002C4 65.2721 6.32811 67.6002 9.2 67.6002Z",
    fill: "#9F9FBC"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M117.737 39.1648V98.0025C117.737 99.7288 116.299 101.167 114.572 101.167H25.1649C23.4386 101.239 22 99.8007 22 98.0744V39.1648C22 37.3666 23.4386 36 25.1649 36H114.572C116.37 36 117.737 37.4385 117.737 39.1648Z",
    fill: "white",
    stroke: "#D3D2E0",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M117.737 39.1648V43.6963H22V39.1648C22 37.3666 23.4386 36 25.1649 36H114.572C116.37 36 117.737 37.4385 117.737 39.1648Z",
    fill: "#F1F1F5",
    stroke: "#D3D2E0",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M56.6696 66.4975C58.1395 66.4975 59.331 65.306 59.331 63.8362C59.331 62.3663 58.1395 61.1748 56.6696 61.1748C55.1998 61.1748 54.0083 62.3663 54.0083 63.8362C54.0083 65.306 55.1998 66.4975 56.6696 66.4975Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M83.1394 66.4975C84.6092 66.4975 85.8007 65.306 85.8007 63.8362C85.8007 62.3663 84.6092 61.1748 83.1394 61.1748C81.6695 61.1748 80.478 62.3663 80.478 63.8362C80.478 65.306 81.6695 66.4975 83.1394 66.4975Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M74.2202 83.9763H65.8765C64.5818 83.9763 63.5029 82.8973 63.5029 81.6026C63.5029 80.3079 64.5818 79.229 65.8765 79.229H74.1483C75.443 79.229 76.522 80.3079 76.522 81.6026C76.5939 82.8973 75.515 83.9763 74.2202 83.9763Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M26.2438 41.1789C26.8397 41.1789 27.3227 40.6958 27.3227 40.1C27.3227 39.5041 26.8397 39.021 26.2438 39.021C25.6479 39.021 25.1649 39.5041 25.1649 40.1C25.1649 40.6958 25.6479 41.1789 26.2438 41.1789Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M29.6244 41.1789C30.2203 41.1789 30.7034 40.6958 30.7034 40.1C30.7034 39.5041 30.2203 39.021 29.6244 39.021C29.0286 39.021 28.5455 39.5041 28.5455 40.1C28.5455 40.6958 29.0286 41.1789 29.6244 41.1789Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M33.0769 41.1789C33.6728 41.1789 34.1559 40.6958 34.1559 40.1C34.1559 39.5041 33.6728 39.021 33.0769 39.021C32.4811 39.021 31.998 39.5041 31.998 40.1C31.998 40.6958 32.4811 41.1789 33.0769 41.1789Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M112.295 31.0471C111.576 31.0471 111 30.4717 111 29.7524V15.2947C111 14.5754 111.576 14 112.295 14C113.014 14 113.59 14.5754 113.59 15.2947V29.7524C113.59 30.4717 113.014 31.0471 112.295 31.0471Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M122.797 42.1238C122.797 41.4045 123.372 40.8291 124.091 40.8291H138.549C139.268 40.8291 139.844 41.4045 139.844 42.1238C139.844 42.8431 139.268 43.4185 138.549 43.4185H124.091C123.372 43.4185 122.797 42.8431 122.797 42.1238Z",
    fill: "#66658D"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M121.646 32.7731C121.142 32.2696 121.142 31.4065 121.646 30.903L131.931 20.6891C132.435 20.1856 133.298 20.1856 133.802 20.6891C134.305 21.1926 134.305 22.0558 133.802 22.5593L123.588 32.7731C123.012 33.2767 122.149 33.2767 121.646 32.7731Z",
    fill: "#66658D"
  })]
});
exports.UnauthorizedImage = UnauthorizedImage;